<p-dialog
  header="Edit Order"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '600px' }"
  (onShow)="onShow()"
>
  <div class="ui-g" style="position: relative">
    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Account code</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="this.accountCodes"
          placeholder="Select account code"
          [disabled]="this.searchingAccountCodes || job?.statusId == jobStatus.Closed"
          [style]="{ width: '100%' }"
          [(ngModel)]="this.selectedAccountCode"
          filter="filter"
        ></p-dropdown>
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Department</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="this.customerDepartments"
          placeholder="Select order department"
          optionLabel="name"
          dataKey="id"
          [disabled]="this.searchingOrderDepartments || this.isCustomerInvoiced"
          [style]="{ width: '100%' }"
          [(ngModel)]="this.selectedOrderDepartment"
          (onChange)="this.departmentChange($event)"
          filter="filter"
        ></p-dropdown>
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Team</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="this.departmentTeams"
          placeholder="Select order Team"
          optionLabel="name"
          dataKey="id"
          [disabled]="
            this.searchingDepartmentTeams ||
            this.searchingOrderDepartments ||
            this.isCustomerInvoiced
          "
          [style]="{ width: '100%' }"
          [(ngModel)]="this.selectedOrderTeam"
          filter="filter"
        ></p-dropdown>
      </div>
    </div>

    <div class="ui-g-12" *ngIf="this.organisationTypeId == 1 || this.organisationTypeId == 2">
      <div class="ui-grid-col-4">
        <label>Purchase Number</label>
      </div>
      <div class="ui-grid-col-8">
        <input
          type="text"
          name="purchaseOrderNo"
          pInputText
          style="width: 100%"
          [disabled]="job?.statusId == jobStatus.Closed"
          [(ngModel)]="this.purchaseOrderNo"
          id="purchaseOrderNo"
          maxlength="50"
        />
      </div>
    </div>

    <div class="ui-g-12" *ngIf="this.organisationTypeId == 1">
      <div class="ui-grid-col-4">
        <label>Customer Price</label>
      </div>
      <div class="ui-grid-col-8">
        <input
          type="number"
          name="orderCustomerPrice"
          pInputText
          style="width: 100%"
          [disabled]="job?.statusId == jobStatus.Closed || this.isOverridePrice"
          [(ngModel)]="this.orderCustomerPrice"
          id="orderCustomerPrice"
        />
      </div>
    </div>

    <div class="ui-g-12" *ngIf="this.organisationTypeId == 1 && this.orderShowInspectionCharge">
      <div class="ui-grid-col-4">
        <label>Inspection Charge</label>
      </div>
      <div class="ui-grid-col-8">
        <input
          type="number"
          name="orderInspectionCharge"
          pInputText
          style="width: 100%"
          [disabled]="job?.statusId == jobStatus.Closed"
          [(ngModel)]="this.orderInspectionCharge"
          id="orderInspectionCharge"
        />
      </div>
    </div>

    <div class="ui-g-12" *ngIf="this.organisationTypeId == 1 || this.organisationTypeId == 2">
      <div class="ui-grid-col-4">
        <label>Tags</label>
      </div>
      <div class="ui-grid-col-8">
        <p-multiSelect
          [options]="this.orderTags"
          [(ngModel)]="this.selectedOrderTags"
          [panelStyle]="{ minWidth: '12em' }"
          [style]="{ width: '100%' }"
          defaultLabel="Please Select"
        ></p-multiSelect>
      </div>
    </div>

    <div class="ui-g-12" *ngIf="this.organisationTypeId == 1">
      <div class="ui-grid-col-4">
        <label>Fix Customer Price</label>
      </div>
      <div class="ui-grid-col-8">
        <p-checkbox
          binary="true"
          name="isOverridePrice"
          [disabled]="job?.statusId == jobStatus.Closed"
          [(ngModel)]="this.isOverridePrice"
          id="isOverridePrice"
        ></p-checkbox>
      </div>
    </div>

    <div class="ui-g-12" *ngIf="this.organisationTypeId == 1">
      <div class="ui-grid-col-4">Cancellation Status</div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="cancellationStatusOptions"
          appendTo="body"
          (onChange)="onCancellationStatusChange()"
          [(ngModel)]="this.cancellationStatusId"
        >
        </p-dropdown>
      </div>
    </div>

    <div *ngIf="displaySecondaryCancellation" class="ui-g-12">
      <div class="ui-grid-col-4">Secondary cancellation status</div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="secondaryCancellationStatusOptions"
          autoWidth="false"
          appendTo="body"
          [(ngModel)]="this.secondaryCancellationStatusId"
        >
        </p-dropdown>
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-4">Why are you cancelling this order?</div>
      <div class="ui-grid-col-8">
        <textarea
          [(ngModel)]="this.cancellationDescription"
          [style]="{ width: '100%' }"
          pInputTextarea
          [rows]="3"
        ></textarea>
      </div>
    </div>

    <div
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: gray;
        opacity: 0.3;
      "
      *ngIf="this.isBusyEditOrder || this.searchOrderTags || this.searchingAccountCodes"
    >
      <img
        src="assets/images/loader.gif"
        style="margin-left: 45%; margin-top: 10%"
        width="50"
        height="50"
        alt="load"
      />
    </div>
  </div>

  <p-footer class="no-rounded-top-border rounded-bottom-border">
    <div class="text-right">
      <button
        type="button"
        (click)="onCancel()"
        pButton
        label="Cancel"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        label="Save"
        class="ui-button ui-button-primary"
        (click)="this.saveEditOrder()"
      ></button>
    </div>
  </p-footer>
</p-dialog>
